import { APP_PERMISSIONS } from '@exam-center/permission';
import { AddIcon, Button, type ButtonProps } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';

import { AdminExamCourseEnablementModal } from '../admin-exam-course-enablement-modal';

type AdminExamCourseEnablementButtonProps = Pick<ButtonProps, 'variant'>;

export default function AdminExamCourseEnablementButton(
  props: Readonly<AdminExamCourseEnablementButtonProps>,
) {
  const { variant = 'contained' } = props;

  const [isOpen, adminExamCourseEnablementModalHandler] = useDisclosure();
  const { open: openAdminExamCourseEnablementModal, close: closeAdminExamCourseEnablementModal } =
    adminExamCourseEnablementModalHandler;

  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_COURSE_MANAGEMENT.SETTINGS.CREATE}
    >
      <Button
        size='large'
        variant={variant}
        startIcon={<AddIcon />}
        onClick={openAdminExamCourseEnablementModal}
      >
        เพิ่มหลักสูตร
      </Button>
      <AdminExamCourseEnablementModal open={isOpen} onClose={closeAdminExamCourseEnablementModal} />
    </WithPermission>
  );
}
